// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VRvjg","question":"styles_question__1z3jX","description":"styles_description__NBXjg"};